import { VENUE_SELECTED } from './actionTypes';

// A venue was selected
const venueSelected = ({ venue }) => ({
  type: VENUE_SELECTED,
  venue,
});

export { venueSelected }; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/actions/venue.js